import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="mt-16 pt-10 border-t border-slate-200 pb-12">
      <div className="flex justify-center gap-6 mb-8 text-slate-400">
        <div className="flex flex-col items-center">
          <SafeIcon icon="Lock" className="text-3xl mb-2" />
          <span className="text-xs font-medium uppercase tracking-wider">Secure</span>
        </div>
        <div className="flex flex-col items-center">
          <SafeIcon icon="Award" className="text-3xl mb-2" />
          <span className="text-xs font-medium uppercase tracking-wider">Guaranteed</span>
        </div>
        <div className="flex flex-col items-center">
          <SafeIcon icon="CheckCircle" className="text-3xl mb-2" />
          <span className="text-xs font-medium uppercase tracking-wider">Verified</span>
        </div>
      </div>

      <div className="text-xs text-slate-500 space-y-4 text-center max-w-3xl mx-auto leading-relaxed px-4">
        <p>
          <strong>Disclaimer:</strong> This is my personal experience. Results may vary depending on individual factors. The information provided on this site is for informational purposes only and is not intended as a substitute for advice from your physician or other health care professional.
        </p>
        <p>
          Always consult your physician before starting any diet, exercise program, or taking any supplement, especially if you have or suspect you might have a health problem, or if you are pregnant or nursing.
        </p>
        <p>
          This site is not a part of the Facebook website or Facebook Inc. Additionally, This site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc.
        </p>
        <p className="pt-4 border-t border-slate-100">
          © {new Date().getFullYear()} Nancy's Wellness Journey. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;